import { createReducer, on } from '@ngrx/store';
import * as WhitelistAddressActions from './whitelist-address.actions';

export interface WhitelistAddressState {
  createLoading: boolean;
  createError: string | null;
  enableLoading: boolean;
  enableError: string | null;
  disableLoading: boolean;
  disableError: string | null;
  deleteLoading: boolean;
  deleteError: string | null;
}

export const initialState: WhitelistAddressState = {
  createLoading: false,
  createError: null,
  enableLoading: false,
  enableError: null,
  disableLoading: false,
  disableError: null,
  deleteLoading: false,
  deleteError: null,
};

export const whitelistAddressReducer = createReducer(
  initialState,

  // Create
  on(WhitelistAddressActions.createWhitelistAddress, state => ({
    ...state,
    createLoading: true,
    createError: null,
  })),

  on(WhitelistAddressActions.createWhitelistAddressSuccess, state => ({
    ...state,
    createLoading: false,
    createError: null,
  })),

  on(
    WhitelistAddressActions.createWhitelistAddressFailure,
    (state, { error }) => ({
      ...state,
      createLoading: false,
      createError: error,
    })
  ),

  // Enable
  on(WhitelistAddressActions.enableWhitelistAddress, state => ({
    ...state,
    enableLoading: true,
    enableError: null,
  })),

  on(WhitelistAddressActions.enableWhitelistAddressSuccess, state => ({
    ...state,
    enableLoading: false,
    enableError: null,
  })),

  on(
    WhitelistAddressActions.enableWhitelistAddressFailure,
    (state, { error }) => ({
      ...state,
      enableLoading: false,
      enableError: error,
    })
  ),

  // Disable
  on(WhitelistAddressActions.disableWhitelistAddress, state => ({
    ...state,
    disableLoading: true,
    disableError: null,
  })),

  on(WhitelistAddressActions.disableWhitelistAddressSuccess, state => ({
    ...state,
    disableLoading: false,
    disableError: null,
  })),

  on(
    WhitelistAddressActions.disableWhitelistAddressFailure,
    (state, { error }) => ({
      ...state,
      disableLoading: false,
      disableError: error,
    })
  ),

  // Delete
  on(WhitelistAddressActions.deleteWhitelistAddress, state => ({
    ...state,
    deleteLoading: true,
    deleteError: null,
  })),

  on(WhitelistAddressActions.deleteWhitelistAddressSuccess, state => ({
    ...state,
    deleteLoading: false,
    deleteError: null,
  })),

  on(
    WhitelistAddressActions.deleteWhitelistAddressFailure,
    (state, { error }) => ({
      ...state,
      deleteLoading: false,
      deleteError: error,
    })
  ),

  // Reset
  on(WhitelistAddressActions.resetState, () => initialState)
);
